<template>
  <router-view />
</template>

<script>

export default {
  name: 'AccountWrapper'
}
</script>
